import {
  B4Regular,
  FlatButton,
  GhostGeneralButton,
  px2rem,
} from "@moim/common";
import styled from "styled-components";
import * as React from "react";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${px2rem(14)};

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${px2rem(120)};
    background: linear-gradient(
      transparent 0%,
      ${props => props.theme.colorV2.colorSet.white400} 30%,
      ${props => props.theme.colorV2.colorSet.white600} 100%
    );
  }
`;

const Description = styled(B4Regular)`
  color: ${props => props.theme.colorV2.colorSet.grey300};
`;

const ButtonWrapper = styled.div.attrs({ tabIndex: -1 })`
  display: flex;
  gap: ${px2rem(16)};
  z-index: ${props => props.theme.zIndexes.default};

  & > * {
    flex: 1;
    min-width: 0;
  }
`;

const Button = styled(FlatButton).attrs({ tabIndex: -1 })``;

const ButtonDescription = styled(B4Regular)`
  margin-bottom: ${px2rem(16)};
  color: ${props => props.theme.colorV2.colorSet.grey300};
`;

export const Buttons: React.FC<{
  buttonText: React.ReactNode;
  buttonDescription?: React.ReactNode;
  disabledButton?: boolean;
  waitingButton?: boolean;
  onClick?: () => void;
}> = ({
  buttonText,
  buttonDescription,
  disabledButton,
  onClick,
  waitingButton,
}) => {
  return (
    <Wrapper>
      {buttonDescription && (
        <ButtonDescription>{buttonDescription}</ButtonDescription>
      )}
      <ButtonWrapper>
        <Button
          disabled={disabledButton}
          waiting={waitingButton}
          size="l"
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};

export { Description };
